import { useEffect, useState } from "react";
import { ArrowClockwise, X } from "@phosphor-icons/react";
import { subscribeUpdate, applyUpdate } from "@/lib/swUpdate";

export default function PwaUpdateBanner() {
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const unsub = subscribeUpdate((available) => {
      if (available) setShow(true);
    });
    return unsub;
  }, []);

  if (!show) return null;

  const onUpdate = () => {
    setBusy(true);
    applyUpdate(); // page reloads once on controllerchange
  };

  return (
    <div
      data-testid="pwa-update-banner"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-md animate-fade-up rounded-2xl border border-[#DDD0FF] bg-white/95 p-4 shadow-[0_18px_40px_-18px_rgba(124,77,224,0.45)] backdrop-blur"
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#EEE6FF] text-[#6A38C7]">
          <ArrowClockwise size={20} weight="bold" />
        </span>
        <div className="flex-1">
          <p className="font-heading text-sm font-extrabold text-slate-800">Versi baru HaloGBS tersedia</p>
          <p className="mt-0.5 text-xs text-slate-500">Perbarui untuk mendapatkan fitur & perbaikan terbaru.</p>
          <div className="mt-3 flex items-center gap-2">
            <button
              data-testid="pwa-update-now"
              onClick={onUpdate}
              disabled={busy}
              className="flex items-center gap-1.5 rounded-xl bg-[#7C4DE0] px-3.5 py-2 text-xs font-bold text-white transition-colors hover:bg-[#6A38C7] active:scale-95 disabled:opacity-60"
            >
              <ArrowClockwise size={15} weight="bold" /> {busy ? "Memperbarui…" : "Perbarui Sekarang"}
            </button>
            <button
              data-testid="pwa-update-later"
              onClick={() => setShow(false)}
              disabled={busy}
              className="rounded-xl px-3 py-2 text-xs font-bold text-slate-500 transition-colors hover:bg-slate-100"
            >
              Nanti
            </button>
          </div>
        </div>
        <button
          data-testid="pwa-update-dismiss"
          onClick={() => setShow(false)}
          className="rounded-lg p-1 text-slate-400 hover:bg-slate-100"
          aria-label="Tutup"
        >
          <X size={16} weight="bold" />
        </button>
      </div>
    </div>
  );
}
